import { useState } from "react";
import { Button } from "antd";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import { LinkOutlined, PlusCircleOutlined } from "@ant-design/icons";
import PppLinksTable from "./components/Ppp-Links-Table/PppLinksTable";
import CreatePppLinkModal from "./components/Create-Ppp-Link-Modal/CreatePppLinkModal";

export default function PppLinks() {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  return (
    <div>
      <GeneralTableHeader
        title="PPP Links"
        description="Create and manage PPP links."
        avatarUrl={<LinkOutlined style={{ fontSize: "30px" }} />}
        actionButtons={[
          <Button
            key="create"
            type="primary"
            onClick={() => setIsCreateOpen(true)}
            icon={<PlusCircleOutlined />}
            size="middle"
          >
            Create New
          </Button>,
        ]}
      />

      <PppLinksTable />

      <CreatePppLinkModal
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
      />
    </div>
  );
}
